<mat-sidenav-container>

  <div fxLayout="row" fxLayoutAlign="center center" class="h-100">

       <form [formGroup]="form" (ngSubmit)="onSubmit(form.value)" fxFlex="80" fxFlex.gt-sm="30" fxFlex.sm="60">
            <mat-card class="p-0 mat-elevation-z24 box">
                <div fxLayout="column" fxLayoutAlign="center center" class="bg-primary box-header">
                    <button mat-fab color="primary" class="mat-elevation-z12" (click)="onSubmit(form.value);">
                        <mat-icon>exit_to_app</mat-icon>
                    </button>
                    <!--<a mat-button routerLink="/register">Don't have an account? Sign up now!</a>-->
                </div>
                <mat-card-content fxLayout="column" fxLayoutAlign="end center" class="box-content" >
                    <mat-card fxLayout="column" fxLayoutAlign="center center" class="mat-elevation-z12 box-content-inner">
                        <span class="box-content-header" *ngIf="!isAuthenticated">Setup Login</span>
                        <span class="box-content-header" *ngIf="isAuthenticated">Select Branch</span>
                        <mat-form-field class="w-100" *ngIf="!isAuthenticated">
                            <input matInput placeholder="User Name" formControlName="email" [readonly]="isAuthenticated" autocomplete="off">
                            <mat-error *ngIf="form.controls.email.errors?.required">user name is required</mat-error>
                            <mat-error *ngIf="form.controls.email.hasError('invalidEmail')">Invalid user name</mat-error>
                        </mat-form-field>
                        <mat-form-field class="w-100" *ngIf="!isAuthenticated">
                            <input matInput placeholder="Password" formControlName="password" type="password" autocomplete="off" [readonly]="isAuthenticated">
                            <mat-error *ngIf="form.controls.password.errors?.required">Password is required</mat-error>
                            <mat-error *ngIf="form.controls.password.hasError('minlength')">Password isn't long enough, minimum of 6 characters</mat-error>
                        </mat-form-field>
                            <mat-form-field *ngIf="isAuthenticated && customerBranch">
                                <mat-label>Select Branch</mat-label>
                                <mat-select [(value)]="selectedCustomerBranchId">
                                    <mat-option *ngFor="let br of customerBranch" [value]="br.customerBranchId">
                                        {{br.customerBranchName}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                    </mat-card>
                    <button mat-raised-button color="primary" (click)="selectCustomerBranch()" class="mat-elevation-z12 box-button" type="button" *ngIf="isAuthenticated && selectedCustomerBranchId > 0">Let's Go!</button>
                    <button mat-raised-button color="primary" class="mat-elevation-z12 box-button" type="submit" *ngIf="!isAuthenticated">SIGN IN</button>
                </mat-card-content>
            </mat-card>
            
        </form>    
  
  </div>

</mat-sidenav-container>